<template>
  <div>
    <el-row class="cs-grey-bottom-border">
      <el-col>
        <span class="cs-homework-title">{{data.courseName}}出勤信息</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>缺课: {{summaryData.AbsentCount}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>旷课: {{summaryData.TruancyCount}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>缺时: {{summaryData.LateCount}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>出勤率: {{summaryData.AttendancePercentageValue.toFixed(1)}}%</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>缺勤率: {{summaryData.AbsentPercentageValue.toFixed(1)}}%</span>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
</style>

<script>
import { getStudentSignSummary } from "../../service/student.service";

export default {
  props: {
    data: {
      studentId: Number,
      courseId: Number,
      courseName: String
    }
  },
  data() {
    return {
      summaryData: {
        AbsentCount:0,
        TruancyCount:0,
        LateCount:0,
        AttendancePercentageValue:0,
        AbsentPercentageValue:0
      }
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.data && !!this.data.courseId && !!this.data.studentId) {
        getStudentSignSummary(0, this.data.courseId, this.data.studentId)
          .then(result => {
            if (result && result.success) {
              this.summaryData = result.data;
            }
            this.$emit("loaded");
          })
          .catch(() => {
            this.$emit("loaded");
          });
      }
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/studentCourseSigninInfo.vue